import { createRouter } from "@tanstack/react-router";
import { noAccessRoute, signInRoute } from "./access";
import { backlogItemRoute, backlogRoute } from "./backlog";
import { evidenceRoute } from "./evidence";
import { homeRoute } from "./home";
import { profileRoute, profilesRoute } from "./profiles";
import { rootRoute } from "./root";
import { searchRoute } from "./search";
import { auditRoute } from "./settings/audit";
import {
  budgetsRoute,
  checksRoute,
  deletedRoute,
  historyRoute,
  pipelineRoute,
  routesSettingsRoute,
  settingsIndexRoute,
} from "./settings/sections";
import { usersRoute } from "./settings/users";
import { gapRoute, sourceRoute, sourcesRoute } from "./sources";
import { taskRoute, tasksRoute } from "./tasks";

const routeTree = rootRoute.addChildren([
  signInRoute,
  noAccessRoute,
  homeRoute,
  backlogRoute.addChildren([backlogItemRoute]),
  evidenceRoute,
  searchRoute,
  sourcesRoute.addChildren([sourceRoute, gapRoute]),
  profilesRoute,
  profileRoute,
  tasksRoute,
  taskRoute,
  settingsIndexRoute,
  usersRoute,
  budgetsRoute,
  historyRoute,
  pipelineRoute,
  checksRoute,
  routesSettingsRoute,
  deletedRoute,
  auditRoute,
]);

export const router = createRouter({ routeTree, defaultPreload: false, scrollRestoration: true });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
